var map = {
	".": "2/Td",
	"./": "2/Td",
	"./01_error_code": "INR5",
	"./01_error_code.json": "INR5",
	"./02_timestamp": "gE9e",
	"./02_timestamp.json": "gE9e",
	"./03_digital_rule": "v0HI",
	"./03_digital_rule.json": "v0HI",
	"./04_rate_limits": "x6dl",
	"./04_rate_limits.json": "x6dl",
	"./05_system_time": "i6gS",
	"./05_system_time.json": "i6gS",
	"./index": "2/Td",
	"./index.js": "2/Td",
	"./index_share_to_v1": "hsbI",
	"./index_share_to_v1.js": "hsbI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "R20p";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/basic ^.*$
// module id = R20p
// module chunks = 3